import React from "react";
import PropTypes from "prop-types";
import ListItem from "ui/PageElement";

const Links = ({ links, organizationSlug, preview=false }) => {

  return (
    <>
      {links.map((pageElement, index) => (
        <ListItem key={index} pageElement={pageElement} organizationSlug={organizationSlug} preview={preview} />
      ))}
    </>
  );
};

Links.propTypes = {
  links: PropTypes.array,
  organizationSlug: PropTypes.string,
  preview: PropTypes.bool
};

export default Links;
